import { MessageType } from '../components/utils/constants'
import { store } from 'react-notifications-component';
import { NotificationType, MessageTypeBody, MessageTypeTitle, NotificationContainerType } from '../components/utils/messageType'
import { TimeOutPortal } from '../components/utils/utils'

export const UseNotification = props => 
    store.addNotification({
        title: getMessageTitle(props.titleType),
        message: getMessage(props.messageType),
        type: getTypeNotification(props.titleType),
        insert: "top",
        container: NotificationContainerType.TOPCENTER,
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
            duration: TimeOutPortal.TimeOutNotification
          }
    });

const getMessageTitle = codigo => {
    switch(codigo) {
        case MessageType.ACCESSERROR: 
            return MessageTypeTitle.accessDenegate;
        case MessageType.OK: 
            return MessageTypeTitle.processOk;
        case MessageType.CONECTIONERROR:
            return MessageTypeTitle.Error;
        case MessageType.PROCESSERROR:
            return MessageTypeTitle.Error;
        case MessageType.PROCESSERROR:
            return MessageTypeTitle.Error;
        default:
            return MessageTypeTitle.Error;
    }
}

const getMessage = codigo => {
    switch(codigo) {
        case MessageType.ACCESSERROR: 
            return MessageTypeBody.accessDenegate;
        case MessageType.OK: 
            return MessageTypeBody.paymentInProcess;
        case MessageType.CONECTIONERROR: 
            return MessageTypeBody.conectionError;
        case MessageType.PROCESSERROR: 
            return MessageTypeBody.processError;
        case MessageType.COMPLETEDATA: 
            return MessageTypeBody.completeData;
        case MessageType.VALIDATEMAIL: 
            return MessageTypeBody.validateMail;
        case MessageType.VALIDATECONFIRMMAIL: 
            return MessageTypeBody.validateConfirmMail;
        default:
            return '';
    }
}

const getTypeNotification = codigo => {
    switch(codigo) {
        case MessageType.ACCESSERROR: 
            return NotificationType.DANGER;
        case MessageType.OK: 
            return NotificationType.SUCCESS;
        case MessageType.CONECTIONERROR: 
            return NotificationType.DANGER;
        default:
            return NotificationType.DANGER;
    }
}